/* @flow */

import IconAddFilled from 'components/icons/filled/add';
import IconArrowUpFilled from 'components/icons/filled/arrowUp';
import IconListFilled from 'components/icons/filled/list';
import IconHomeFilled from 'components/icons/filled/home';
import IconSuitcaseFilled from 'components/icons/filled/suitcase';
import IconRefreshFilled from 'components/icons/filled/refresh';
import IconUsersFilled from 'components/icons/filled/users';

import {
  PROTECTED_SUPPLIER_DASHBOARD,
  PROTECTED_SUPPLIER_OFFER,
} from 'constants/pageRoutes';

export const supplierMenuData = [
  {link: PROTECTED_SUPPLIER_DASHBOARD, icon: <IconHomeFilled color='primary' size='1.5x'/>, messageId: 'sidebar.page.home'}
  // {link: PROTECTED_SUPPLIER_OFFER, icon: <IconRefreshFilled color='primary' size='1.5x'/>, messageId: 'sidebar.page.offer', pageName: 'POS.Suppliers.SidebarMenu', elementName: 'menuOffer'},
];
